import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import AdminApp from './AdminApp.tsx'
import './index.css'
import { AuthProvider } from './contexts/AuthContext'
import { ClientIntakePage } from './pages/ClientIntakePage'
import { DocumentUploadPage } from './pages/DocumentUploadPage'
import { SignPage } from './pages/SignPage'
import { PortalPage } from './pages/PortalPage'
import { VerificationStatusPage } from './pages/VerificationStatusPage'

// Client intake links are unauthenticated, so they render outside AuthProvider
// entirely rather than going through the login-gated App shell.
const inviteMatch = window.location.pathname.match(/^\/client-intake\/([^/]+)\/?$/)
// Matter upload links are the same deal — durable, unauthenticated, token in
// the URL is the credential (see backend/src/index.ts's resolveUploadLinkToken).
const uploadLinkMatch = window.location.pathname.match(/^\/upload\/([^/]+)\/?$/)
// Signer links — same trust model again, see backend/src/esign.ts.
const signMatch = window.location.pathname.match(/^\/sign\/([^/]+)\/?$/)
// Client portal (checklist + document upload + starting ID verification) —
// one link per (matter, client) pair, gated by the token plus the client's
// own email/postcode as a second factor (see backend/src/index.ts's
// resolvePortalLinkToken/verifyPortalCredentials).
const portalMatch = window.location.pathname.match(/^\/portal\/([^/]+)\/?$/)
// Dedicated, unauthenticated landing page for Didit's hosted-verification
// redirect (see backend/src/index.ts's startDiditVerification callback) —
// same portal-link token as portalMatch above, but its own route so it can
// give immediate feedback without loading the full portal. Never calls the
// backend itself; see VerificationStatusPage for why.
const verificationStatusMatch = window.location.pathname.match(/^\/verification-status\/([^/]+)\/?$/)

// admin.<domainName> is served by the same S3/CloudFront distribution as the
// tenant app (see infra/lib/micro-conveyo-stack.ts) — the build picks the
// admin dashboard purely by hostname. The /admin path fallback exists so the
// dashboard is reachable from a plain localhost dev server without editing
// /etc/hosts.
const isAdminHost = window.location.hostname.startsWith('admin.') || window.location.pathname.startsWith('/admin')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {inviteMatch ? (
      <ClientIntakePage inviteId={inviteMatch[1]} />
    ) : uploadLinkMatch ? (
      <DocumentUploadPage token={uploadLinkMatch[1]} />
    ) : signMatch ? (
      <SignPage token={signMatch[1]} />
    ) : portalMatch ? (
      <PortalPage token={portalMatch[1]} />
    ) : verificationStatusMatch ? (
      <VerificationStatusPage token={verificationStatusMatch[1]} />
    ) : isAdminHost ? (
      <AdminApp />
    ) : (
      <AuthProvider>
        <App />
      </AuthProvider>
    )}
  </React.StrictMode>,
)
